class SettingsSidebarController {
  constructor($state) {
    "ngInject";
    this.name = 'settingsSidebar';
    this.state = $state;
  }


}

export default SettingsSidebarController;



// WEBPACK FOOTER //
// ./client/common/settings-sidebar/settings-sidebar.controller.js